export var SessionReplayQuality;
(function (SessionReplayQuality) {
    SessionReplayQuality["Low"] = "low";
    SessionReplayQuality["Medium"] = "medium";
    SessionReplayQuality["High"] = "high";
})(SessionReplayQuality || (SessionReplayQuality = {}));
//# sourceMappingURL=session-replay-quality.js.map